import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics'
import 'firebase/firestore'

const config = {
    apiKey: "AIzaSyBZSWipZoOyGrMqNEUMyJvBonharOAq-UE",
    authDomain: "auth-77393.firebaseapp.com",
    projectId: "auth-77393",
    messagingSenderId: "577419363426",
    appId: "1:577419363426:web:fae7e02684585fa59e7d3b",
    measurementId: "G-YNNYCKXXP4"

};
export default firebase.initializeApp(config);